export class Amount {
  public Currency: string;

  public Total: number;
}
